import type { HTMLAttributes } from "react";

import { cn } from "@/lib/helpers/cn";

export function ReminderContainer(props: HTMLAttributes<HTMLDivElement>) {
  return (
    <section
      className={cn("tw:flex tw:flex-col tw:gap-5", "tw:not-[:empty]:mb-6 tw:empty:hidden")}
      {...props}
    />
  );
}
